import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import Avatar from "components/Illustrations/Avatar";

const CARDS = [
  {x: 34, color: '#5BA8DE'},
  {x: 95, color: '#F08A6E'},
  {x: 156, color: '#7FC79A'},
];

const useStyles = makeStyles({
  card: {
    animation: '$glow 4.5s ease-in-out infinite',
  },
  magnifier: {
    animation: '$sweep 4.5s ease-in-out infinite',
  },
  '@keyframes glow': {
    '0%, 100%': {fill: '#fff'},
    '8%, 22%': {fill: '#FFE7A3'},
  },
  '@keyframes sweep': {
    '0%, 100%': {transform: 'translateX(0)'},
    '33%': {transform: 'translateX(62px)'},
    '66%': {transform: 'translateX(124px)'},
  },
  '@media (prefers-reduced-motion: reduce)': {
    card: {animation: 'none'},
    magnifier: {animation: 'none'},
  },
});

const ProfileSearchArt = ({className}) => {
  const classes = useStyles();

  return (
    <svg className={className} viewBox="30 6 180 168" fill="none" stroke="#2B3A55" strokeWidth={3}
         strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx={120} cy={90} r={80} fill="#FFF6E5" stroke="none"/>
      {CARDS.map(({x, color}, index) => (
        <g key={x}>
          <rect className={classes.card} style={{animationDelay: `${index * 1.5}s`}}
                x={x} y={62} width={50} height={64} rx={10} fill="#fff"/>
          <Avatar x={x + 25} y={86} size={0.6} color={color}/>
          <path d={`M${x + 12} 108h26M${x + 16} 116h18`} strokeWidth={2.5} opacity={0.4}/>
        </g>
      ))}
      <g className={classes.magnifier}>
        <circle cx={62} cy={84} r={20} fill="#fff" fillOpacity={0.35} strokeWidth={4}/>
        <path d="M76 98l14 14" strokeWidth={7}/>
        <path d="M54 76a10 10 0 0 1 8-4" stroke="#fff"/>
      </g>
    </svg>
  );
};

export default ProfileSearchArt;
